<script lang="ts">
  import type { NavItem } from "types/backend/models/admin/navbar.entity";
  import { locale } from "$lib/services/i18n";

  export let data: NavItem;
  export let closeMenu: (ev: Event) => void;

  let classes = [
    "nav-item",
    data.mobileShow ? "mobile" : "",
    data.tabletShow ? "tablet" : "",
    data.desktopShow ? "desktop" : "",
  ];

  const { label = "", url, separator = false } = data;
</script>

<li on:click={closeMenu} on:keydown={closeMenu} role="menuitem" tabindex="0" class={classes.join(" ")}>
  {#if separator}
    <hr class="nav-separator" />
  {:else}
    <a href={`/${$locale}${url}`} class="sf-600">
      {label}
    </a>
  {/if}
  <slot />
</li>

<style lang="scss">
  @use "@styles/breakpoint-mixins" as *;

  .nav-item {
    display: none;
    max-width: 90vw;
    padding: 0;
    margin: 0;
    margin-bottom: 1.125rem;
    @include desktop {
      margin-bottom: unset;
    }

    hr.nav-separator {
      border-top: 1px solid var(--hr-color);
      height: 1px;
      width: 100%;
    }

    a {
      text-decoration: none;
      /* text-transform: capitalize; */
      cursor: pointer;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      color: #000;
      font-size: 1.25rem;
      @include desktop {
        font-size: 1rem;
      }
    }

    @include desktop {
      height: unset;
      max-width: unset;
    }

    &.mobile {
      display: flex;

      @include tablet {
        display: none;
      }
    }

    &.tablet {
      @include tablet {
        display: flex;
      }

      @include desktop {
        display: none;
      }
    }

    &.desktop {
      @include desktop {
        display: flex;
      }
    }
  }
</style>
